import { useState } from 'react';
import { getFileUrl, getFileName } from '../../utils/fileUtils';

/**
 * Hook to manage attachment dialog state
 * @returns {Object} Dialog state and handlers
 */
export const useAttachmentDialog = () => {
  const [attachmentDialogOpen, setAttachmentDialogOpen] = useState(false);
  const [selectedAttachment, setSelectedAttachment] = useState(null);

  const handleAttachmentClick = (file) => {
    setSelectedAttachment(file);
    setAttachmentDialogOpen(true);
  };

  const handleCloseAttachmentDialog = () => {
    setAttachmentDialogOpen(false);
    setSelectedAttachment(null);
  };

  const handleDownloadAttachment = (file) => {
    const url = getFileUrl(file);
    if (url) {
      const link = document.createElement('a');
      link.href = url;
      link.download = getFileName(file);
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return {
    attachmentDialogOpen,
    selectedAttachment,
    handleAttachmentClick,
    handleCloseAttachmentDialog,
    handleDownloadAttachment,
  };
};
